module.exports = __webpack_public_path__ + "static/media/css_logo.670c0bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/css_logo.png
// module id = 408
// module chunks = 1